import { sanitize } from "isomorphic-dompurify";
import { Buffer } from "buffer";

export const DecodedBase64 = ({ base64Text }: { base64Text: string }) => (
  <div
    dangerouslySetInnerHTML={{
      __html: sanitize(Buffer.from(base64Text, "base64").toString("utf8")),
    }}
  />
);
